import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CAPTION_BLUR_RANGE,
  CAPTION_SHADOW_OFFSET_RANGE,
} from '@vbee-holding/aivoice-shared-lib';
import GroupHeader from './controls/GroupHeader';
import ConfigRow from './controls/ConfigRow';
import SliderField from './controls/SliderField';
import ColorField from './controls/ColorField';

const CONTROL_WIDTH = 200;

const ShadowGroup = ({ shadow, onChange }) => {
  const { t } = useTranslation();
  const { enabled } = shadow;

  return (
    <div className="config-group">
      <GroupHeader
        label={t('captionShadow')}
        enabled={enabled}
        onToggle={(next) => onChange({ enabled: next })}
      />

      <div className="config-group-rows">
        <ConfigRow label={t('captionShadowColor')} disabled={!enabled}>
          <ColorField
            value={shadow.color}
            opacity={shadow.opacity}
            disabled={!enabled}
            onChange={(color) => onChange({ color })}
            onOpacityChange={(opacity) => onChange({ opacity })}
          />
        </ConfigRow>

        <ConfigRow label={t('captionShadowBlur')} disabled={!enabled}>
          <SliderField
            width={CONTROL_WIDTH}
            value={shadow.blur}
            range={CAPTION_BLUR_RANGE}
            onChange={(blur) => onChange({ blur })}
          />
        </ConfigRow>

        {/* Ký hiệu trục, không đổi theo ngôn ngữ nên không đưa vào i18n. */}
        <ConfigRow label="X" disabled={!enabled}>
          <SliderField
            width={CONTROL_WIDTH}
            value={shadow.offsetX}
            range={CAPTION_SHADOW_OFFSET_RANGE}
            onChange={(offsetX) => onChange({ offsetX })}
          />
        </ConfigRow>

        <ConfigRow label="Y" disabled={!enabled}>
          <SliderField
            width={CONTROL_WIDTH}
            value={shadow.offsetY}
            range={CAPTION_SHADOW_OFFSET_RANGE}
            onChange={(offsetY) => onChange({ offsetY })}
          />
        </ConfigRow>
      </div>
    </div>
  );
};

export default ShadowGroup;
